import { ReactNode, createContext, useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { IDuesSponsoredOrgContextType } from "../interfaces/IDuesSponsoredOrgContextType";
import { IOrganization } from "../interfaces/IOrganization";
import { useAuthenticationContext } from "../hooks/useAuthenticationContext";
import { useErrorContext } from "../hooks/useErrorContext";

//The authorization context object holds the latest IAuthorizationContextType.
export const DuesSponsoredOrgContext = createContext<IDuesSponsoredOrgContextType | undefined>(undefined);

//This component is responsible to manage the customerkey, token and unfiltered roles state and provide it through the application component tree.
export const DuesSponsoredOrgProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [organizations, setOrganizations] = useState<IOrganization[]>();
    const [selectedOrganization, setSelectedOrganization] = useState<IOrganization | undefined>();
    const [loadingDuesSponsorCtx, setLoadingDuesSponsorCtx] = useState<boolean>();
    const { cstKey } = useAuthenticationContext();
    const GET_DUES_SPONSORED_ORG_URI = `${process.env.REACT_APP_GET_DUES_SPONSORED_ORGS}${cstKey}`;
    const { setError } = useErrorContext();


    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        setLoadingDuesSponsorCtx(false);
    };

    // Function to fetch organization data using the REACT_APP_API_GET_ORGS api endpoint.
    const GetOrganizationsFetch = async () => {
        try {
            setLoadingDuesSponsorCtx(true);
            const response = await fetch(GET_DUES_SPONSORED_ORG_URI);
            if (!response.ok) {
                console.log("getOrgs", response.statusText);
                setLoadingDuesSponsorCtx(false);
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, 1);
            } else {
                setOrganizations(result.Organizations);
            }
        } catch (error: any) {
            console.log("getOrgs error", error);
            handleError(null, error.status);
        } finally {
            setLoadingDuesSponsorCtx(false);
        }
    };

    useEffect(() => {
        GetOrganizationsFetch();
    }, [cstKey]);

    const value = {
        organizations,
        selectedOrganization,
        setOrganizations,
        setSelectedOrganization
    }

    return (
        <DuesSponsoredOrgContext.Provider value={value}>
            {!loadingDuesSponsorCtx && (children)}
        </DuesSponsoredOrgContext.Provider>
    );
}